
const formatDateRang = (props) => {
    if (props && props.split(" - ").length === 2) {
        var split = props.split(" - ");
        var f = split[0].split("/");
        var l = split[1].split("/");
        var d = f[2] + "-" + f[1] + "-" + f[0] + ":" + l[2] + "-" + l[1] + "-" + l[0];
        var date = d.replace(/ /g, "");
        return date;
    } else {
        return "";
    }
}

export default formatDateRang;